import React from 'react';
import { connect } from 'react-redux';
import * as selectors from 'selectors/assign';
import AssignStep from './AssignStep';
import NextStepButton from './NextStepButton';
import SchedulingOptions from './shared/SchedulingOptions';

const Navigator = props => (
  <div className="AssignModal-navigator">
    <AssignStep
      selectables={props.selectedContent}
      count={props.contentCount}
      name="CONTENT"
      label="Content"
    />
    <AssignStep
      selectables={props.selectedAssignees}
      count={props.assigneesCount}
      name="ASSIGNEES"
      label="Assignees"
    />
    <AssignStep name="SCHEDULING" label="Scheduling">
      {props.hasScheduled && <SchedulingOptions />}
    </AssignStep>
    <AssignStep
      name="REVIEW"
      label="Review and Assign"
      locked={!props.canReview}
    />
    <NextStepButton toggleContainer={props.toggleContainer} />
  </div>
);

const mapStateToProps = state => ({
  contentCount: state.selection.content.data.length,
  assigneesCount: state.selection.assignees.count,
  selectedContent: state.selection.content.data,
  selectedAssignees: state.selection.assignees.data,
  canReview: selectors.isReadyToAssign(state),
  hasScheduled: selectors.hasScheduleOptions(state),
});

export default connect(mapStateToProps)(Navigator);
